import { jsx as _jsx } from "react/jsx-runtime";
import { ATS_Frontend, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { Component_DependencyViewer } from '../../dependency-viewer/Component_DependencyViewer.js';
export class ATS_DependencyViewer extends ComponentSync {
    static defaultProps = {};
    static screen = {
        name: 'Dependency Graph',
        key: 'dependency-graph',
        renderer: this,
        group: ATS_Frontend
    };
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        return _jsx(Component_DependencyViewer, {});
    }
}
//# sourceMappingURL=ATS_DependencyGraph.js.map